<template>
<div class="zhaopuserve">
    <div class="zp-top" v-if="showNav">
        <img class="navBack" @click.stop="back()" src="../../../static/images/shootShop/back.png" alt="" >
        <span>极速转铺</span>
    </div>
    <div class="zp-title">租铺宝·极速转铺服务</div>
    <div class="zp-list">
        <h3>平均32天出租成功 最快48小时成交</h3>
        <div class="zp-box">
            <h4>专享&nbsp;4&nbsp;大转铺特权</h4>
            <h5>近20万名店主与房东成功合作</h5>
            <h5>超10万真实选址品牌与商户资源</h5>
            <div class="div-box div1">
                <dl>
                    <dt><img src="../../../static/images/zpserve/icon1.png"></dt>
                    <dd>置顶推广</dd>
                </dl>
                <dl>
                    <dt><img src="../../../static/images/zpserve/icon2.png"></dt>
                    <dd>客户查看</dd>
                </dl>
                <dl>
                    <dt><img src="../../../static/images/zpserve/icon5.png"></dt>
                    <dd>58推广</dd>
                </dl>
                <dl>
                    <dt><img src="../../../static/images/zpserve/icon8.png"></dt>
                    <dd>线上一对一</dd>
                </dl>
               <!-- <dl>
                    <dt><img src="../../../static/images/zpserve/icon3.png"></dt>
                    <dd>铺源专享</dd>
                </dl> -->
               <!-- <dl>
                    <dt><img src="../../../static/images/zpserve/icon4.png"></dt>
                    <dd>微信推广</dd>
                </dl> -->
            </div>
            <!--  <div class="div-box div2">
                
               <dl>
                    <dt><img src="../../../static/images/zpserve/icon6.png"></dt>
                    <dd>线下拓客</dd>
                </dl>
                <dl>
                    <dt><img src="../../../static/images/zpserve/icon7.png"></dt>
                    <dd>人工匹配</dd>
                </dl>
            </div> -->
            <div class="btn" v-for="(item,index) in priceArr" v-if="index == 0">
                <p>{{item.price}}元/周</p>
                <div @click="fuwubuy(item)"><img src="../../../static/images/zpserve/btn1.png"></div>
            </div>
        </div>
        <ul class="zp-ul">
            <li>
                <div><i></i><span>租铺宝平台置顶推广</span></div>
                <p>优先展示&nbsp;提升曝光&nbsp;平台认证</p>
            </li>
            <!--<li>
                <div><i></i><span>找店客户电话查看</span></div>
                <p>浏览咨询客户电话随时查，客户从此不流失。</p>
            </li>-->
            <!--<li>
                <div><i></i><span>智能匹配找店客户</span></div>
                <p>线上、线下跨平台多渠道筛选适合您的商铺</p>
            </li>-->
            <!--<li>
                <div><i></i><span>全程服务</span></div>
                <p>10万+找店客户&nbsp;大数据精准配客</p>
            </li>-->
            <li>
                <div><i></i><span>58平台联合推广</span></div>
                <p>58同城战略合作 对接全网需求</p>
            </li>
            <li>
                <div><i></i><span>开店人微信群推广</span></div>
                <p>万人开店微信群推广&nbsp;轻松助力转铺</p>
            </li>
            <!--<li>
                <div><i></i><span>线下渠道挖掘拓客</span></div>
                <p>线下中介门面合作拓客，全渠道覆盖找店客户。</p>
            </li>-->
            <!--<li>
                <div><i></i><span>人工精准匹配</span></div>
                <p>专属顾问一对一服务，全渠道筛选意向客户。</p>
            </li>-->
            <!--<li>
                <div><i></i><span>撮合议价签约辅助</span></div>
                <p>专属顾问帮您议价，签约交割全程协助。</p>
            </li>-->
        </ul>
    </div>
</div>
</template>

<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';
  export default {
    data(){
        return{
            tab:0,
            android: "",
            ios:"",
            news: "",
            shopId: "",
            shopDetail:"",
            price: 0,

            priceArr: [],

            // 找铺会员
            seekShopMemberArr: [],
            // 转铺会员
            turnShopMemberArr: [],
            // vip选址服务
            vipSiteServeArr: [],
            // vip转铺服务
            vipTurnShopServeArr: [],

            appType: "",
            appCityId: "",

            showNav: true

        }
    },
    computed:{

    },
    mounted(){
       

        //截取Url里面的参数
        function GetRequest() {
            var url = location.search; //获取url中"?"符后的字串
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var str = url.substr(1);
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        }
        var request = new Object();
        request = GetRequest();

        // var tab1 = request['tab'];

        this.appType = request['app'];

        this.appCityId = request['cityId'];

        let that = this;
        setTimeout(function () {
            that.memberData(); 
        },10);

        if(this.appType == 'ios'){
            this.showNav = false;
            $(".zp-title").css({ "margin-top": "0" });
        }else if(this.appType == 'android'){
            this.showNav = false;
            $(".zp-title").css({ "margin-top": "0" });
        }



        // if(tab1 == "1"){
        //     this.tab = 1;
        // }else if(tab1 == "2"){
        //     this.tab = 2;
        // }else if(tab1 == "3"){
        //     this.tab = 3;
        // }else{
        //     this.tab = 0;
        // }

    },
    methods:{
        back(){

            if(this.appType == 'android'){
                return AndroidDial.showToast("3");
            }else{
                if(this.$route.query.mine){
                    this.$router.push({path:"/mine"})
                }else if(this.$route.query.shopDetail){
                    this.$router.push({path:"/shopDetail",query:{shopId:this.$route.query.shopId,buyMember:this.$route.query.shopDetail}})
                }else if(this.$route.query.payMember){
                    this.$router.push({path:"/shopDetail",query:{shopId:this.$route.query.shopId,buyMember:this.$route.query.payMember}})
                }else if(this.$route.query.order){
                    this.$router.push({path:"/order"})
                }else if(this.$route.query.url){
                    this.$router.push({path:this.$route.query.url,query:{urlType:this.$route.query.urlType}})
                }else{
                    this.$router.go(-1)
                }
            }
            
        },
        // 购买会员
        // huiyuanbuy(item){

        //     if(this.appType == 'ios'){

        //         window.location.href="next://" + item.id;

        //     }else if(this.appType == 'android'){

        //         return AndroidBuy.showToast(item.id);

        //     }else{

        //         this.$router.push({path:"/payment",query:{"id":item.id,"price":item.price,buyMember:this.$route.query.shopDetail,shopId:this.$route.query.shopId}});
        //     }

        // },

        // 购买转铺会员
        fuwubuy(item){

            if(this.appType == 'ios'){

                window.location.href="next://" + item.id;

            }else if(this.appType == 'android'){

                return AndroidBuy.showToast(item.id);

            }else{

                this.$router.push({path:"/payment",query:{"id":item.id,"price":item.price,buyMember:this.$route.query.shopDetail,shopId:this.$route.query.shopId,tab:"1"}});
            }

        },


        // 获取产品信息
        memberData(){
            // 接口调用
            let _this = this;
            let url = _this.changeData() + '/member/selectProductList'
            axios(url,{
                method: 'post',
                // url: url,
                params: {
                    type: 4, // 0 找铺会员 4 转铺会员 1 VIP选址服务  2 vip转铺服务
                    cityId: this.appCityId || sessionStorage.cityId // 市id
                }
                // params: obj
            }).then(data => {

                this.priceArr = data.data.productList;

            }).catch(err => {
                console.log(err)
            });
        }
    }
}
</script>
<style scoped lang="scss" type="text/scss">
.zhaopuserve{
    width: 7.5rem;
    margin: 0 auto;
    padding-bottom: 1.5rem;
}
.zp-top{
    width: 7.5rem;
    height: 1.1rem; 
    border-bottom: 1px solid #f2f2f2;
    text-align: center;
    font-size: .36rem;
    font-weight: 400;
    color: #0f1923;
    line-height: 1.1rem;
    position: fixed;
    left: auto;
    top: 0;
    background: #fff;
    z-index: 9;
    .navBack{
        width: .2rem;
        height: .33rem;
        position: absolute;
        left: .4rem;
        top: .38rem;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
}
.zp-title{
    width: 100%;
    height: 1.48rem;
    font-size: .44rem;
    font-family: PingFangSC-Medium,PingFang SC;
    font-weight: 500;
    color: #fff;
    line-height: 1.48rem;
    text-align: center;
    background: #de4b4f;
    margin-top: 1.1rem;
}
.zp-list{
    h3{
        font-size: .32rem;
        font-family: PingFangSC-Regular,PingFang SC;
        font-weight: 400;
        color: #2b2b2b;
        line-height: .44rem;
        text-align: center;
        margin: .32rem 0;
    }
}
.zp-box{
    width: 6.6rem;
    height: 8.46rem;
    background: #de4b4f;
    box-shadow: 0px 4px 8px 0px rgba(211,211,211,0.5);
    border-radius: 8px;
    margin: 0 auto;
    h4{
        width: 5.16rem;
        font-size: .4rem;
        font-family: PingFangSC-Semibold,PingFang SC;
        font-weight: 600;
        color: #fff;
        line-height: .56rem;
        text-align: center;
        padding: .34rem 0 .38rem;
        border-bottom: 2px solid #fff;
        margin: 0 auto .18rem;
    }
    h5{
        font-size: .24rem;
        font-family: PingFangSC-Regular,PingFang SC;
        font-weight: 400;
        color: #fff;
        line-height: .34rem;
        text-align: center;
    }
}
.div-box{
    width: 5.8rem;
    height: 1.2rem;
    padding: 0 .4rem;
    margin-top: .68rem;
    dl{
        float: left;
        width: 25%;
        text-align: center;
        dt{
            width: .76rem;
            height: .76rem;
            margin: 0 auto;
            img{
                width: .76rem;
                height: .76rem;
            }
        }
        dd{
            font-size: .24rem;
            font-family: PingFangSC-Regular,PingFang SC;
            font-weight: 400;
            color: #fff;
            line-height: .34rem;
        }
    }
}
.btn{
    p{
        font-size: .32rem;
        font-family: PingFangSC-Regular,PingFang SC;
        font-weight: 400;
        color: #fff;
        line-height: .44rem;
        text-align: center;
        margin: .78rem 0 .1rem;
    }
    div{
        width: 4.84rem;
        height: 1.06rem;
        margin: 0 auto;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        img{
            width: 4.84rem;
            height: 1.06rem;
        }
    }
}
.zp-ul{
    width: 6.4rem;
    margin: 0 auto;
    li{
        margin-top: .3rem;
        div{
            height: .4rem;
            i{
                width: .08rem;
                height: .3rem;
                background: #de4b4f;
                display: inline-block;
                margin-right: .18rem;
                position: relative;
                top: .04rem;
                left: 0;
            }
            span{
                font-size: .26rem;
                font-family: PingFangSC-Medium,PingFang SC;
                font-weight: 500;
                color: #383a42;
                line-height: .36rem;
                display: inline-block;
            }
        }
        p{
            width: 6.1rem;
            height: .84rem;
            padding-left: .3rem;
            font-size: .2rem;
            font-family: PingFangSC-Regular,PingFang SC;
            font-weight: 400;
            color: #383a42;
            line-height: .28rem;
            background: #f2f2f2;
            line-height: .84rem;
            margin-top: .2rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/home/zhuanpuserve.vue